import { useLayoutEffect, useState } from 'react'

// Context menus portalled to document.body with position: fixed are placed
// from their trigger's rect. This keeps that
// rect current while the menu is open: without it the menu stays where it
// opened when the page or the table scrolls. Scroll doesn't bubble, so the
// listener captures to hear any scrolling ancestor.
export const useMenuTriggerRect = (triggerRef, isOpen) => {
  const [triggerRect, setTriggerRect] = useState(null)

  useLayoutEffect(() => {
    if (!isOpen) {
      setTriggerRect(null)
      return
    }

    const updateTriggerRect = () => {
      if (!triggerRef.current) return

      setTriggerRect(triggerRef.current.getBoundingClientRect())
    }

    updateTriggerRect()

    window.addEventListener('scroll', updateTriggerRect, { capture: true })
    window.addEventListener('resize', updateTriggerRect)

    return () => {
      window.removeEventListener('scroll', updateTriggerRect, {
        capture: true
      })
      window.removeEventListener('resize', updateTriggerRect)
    }
  }, [isOpen, triggerRef])

  return triggerRect
}
